import { useSelector } from 'react-redux'
import { HugeiconsIcon } from '@hugeicons/react'
import {
    ArrowDown01Icon,
    ArrowUp01Icon,
    Delete02Icon,
    DragDropHorizontalIcon,
    SquareIcon,
} from '@hugeicons-pro/core-stroke-rounded'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'

import { selectCollapsedItems } from '@/app/slices/orderItemsSlice'

import OrderItemStatus from '../common/OrderItemStatus'

const classes = {
    Overlay: {
        borderRadius: 2,
        overflow: 'hidden',
        backgroundColor: 'primary.main',

        boxShadow: 15,
        zIndex: 10,
    },

    OverlayContent: {
        px: 2,
        py: 1.5,
        display: 'flex',
        justifyContent: 'space-between',
        height: 74,
    },

    OverlayContentLeft: {
        gap: 1.5,
    },

    OverlayContentRight: {
        gap: 6,
    },

    OverlayContentColor: {
        color: 'primary.contrastText',
    },
    OverlayDetailsContent: {
        height: 436,
        backgroundColor: 'primary.light',
    },
}

const OrderItemOverlay = ({ id, name, ref, ...props }) => {
    const collapsedItemsArray = useSelector(selectCollapsedItems)

    const isCollapsed = collapsedItemsArray.includes(id)

    return (
        <Box
            sx={classes.Overlay}
            {...props}
            ref={ref}
        >
            <Box sx={classes.OverlayContent}>
                <Box
                    sx={[
                        {
                            alignItems: 'center',
                            display: 'flex',
                        },
                        classes.OverlayContentLeft,
                    ]}
                >
                    <IconButton
                        size="small"
                        sx={classes.OverlayContentColor}
                    >
                        <HugeiconsIcon icon={DragDropHorizontalIcon} />
                    </IconButton>

                    <HugeiconsIcon
                        icon={SquareIcon}
                        size={18}
                        sx={classes.OverlayContentColor}
                    />

                    <Box
                        sx={{
                            alignItems: 'center',
                            display: 'flex',
                            gap: 2,
                        }}
                    >
                        <OrderItemStatus status="overlay" />

                        <Typography sx={classes.OverlayContentColor}>{name}</Typography>
                    </Box>
                </Box>

                <Box
                    sx={[
                        {
                            alignItems: 'center',
                            display: 'flex',
                        },
                        classes.OverlayContentRight,
                    ]}
                >
                    <Box
                        sx={{
                            alignItems: 'center',
                            display: 'flex',
                        }}
                    >
                        <IconButton sx={classes.OverlayContentColor}>
                            <HugeiconsIcon
                                icon={Delete02Icon}
                                size={20}
                            />
                        </IconButton>

                        <HugeiconsIcon
                            altIcon={ArrowDown01Icon}
                            color="white"
                            icon={ArrowUp01Icon}
                            showAlt={isCollapsed}
                        />
                    </Box>
                </Box>
            </Box>
            {!isCollapsed ? <Box sx={classes.OverlayDetailsContent}></Box> : null}
        </Box>
    )
}

OrderItemOverlay.displayName = 'OrderItemOverlay'

OrderItemOverlay.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
}

export default OrderItemOverlay
